export default "__VITE_ASSET__Oh048sb4__"